import type { FC } from 'react'

import type { IEvent } from '../../api/interfaces/events/interfaces.model'
import { pagesDataAPI } from '../../axios/axios'
import type { IEventsBody } from '../../home/HomePageContent/Body/Body'
import { Error } from '../error/error'
import { SelectedEventContent } from './content/SelectedEventContent'

interface ISelectedEventsProps {
  error: boolean
  selectedEvent: IEvent
  recommendedEvents: IEventsBody[]
}

const SelectedEvent: FC<ISelectedEventsProps> = ({
  error,
  selectedEvent,
  recommendedEvents,
}) =>
  error ? (
    <Error />
  ) : (
    <SelectedEventContent
      selectedEvent={selectedEvent}
      recommendedEvents={recommendedEvents}
    />
  )

export default SelectedEvent

export async function getServerSideProps(
  context: Record<string, Record<string, number>>,
) {
  const { id } = context.query
  try {
    const recomendedEvent = await pagesDataAPI.getRecomendedEvent(id)
    const event = await pagesDataAPI.getEvent(id)
    const { data } = event.data
    const { data: recommendedData } = recomendedEvent.data
    return {
      props: {
        recommendedEvents: recommendedData,
        selectedEvent: data,
      },
    }
  } catch (e) {
    return {
      props: {
        error: true,
      },
    }
  }
}
